export default __webpack_public_path__ + "static/media/downArrow.a9fb83fc.svg";